import React from "react";
import type { GetStaticPropsContext, NextPage } from "next";

import { IProjectList } from "@components-pages/proyectos/ProjectList";
import en from "lang/en.json";
import es from "lang/es.json";
import { CPagesPath } from "shared/models/const/pages-path";
import RealestateList from "@components-pages/proyectos/RealestateList";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

const IWantToRent: NextPage = (props) => {
  const filters: IProjectList = {
    filters: {
      businessTypes: "lease",
    },
    refRequest: "property-list-lease",
    detailPath: CPagesPath.es.property_detail,
  };

  const metaData: IHeadMetaComponent = {
    title: "iWantToRent",
    description: "iWantToRent",
    keyWords: CKeyWordsPages.iWantToRent,
  };

  return (
    <>
      <HeadMeta {...metaData} />
      <RealestateList defaultFilters={filters} />
    </>
  );
};

export default IWantToRent;
